<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<template>
  <div v-if="showStart" class="main">
    <img class="logo" src="../assets/swam_t_logo.png" />
    <h1 class="title">SWAM-T</h1>
    <div v-if="imLoading" class="loading-container">
      <div class="loader"></div>
    </div>
    <button v-else @click="onStartButton" class="star-button">开始</button>
    <label class="verison-text">v1.2.3.4(test)</label>
  </div>
  <div v-else-if="startClicked" class="main">
    <div v-if="items" class="control-container">
      <div class="row">
        <button class="back" @click="onBack">
          <img class="swamt-back" src="../assets/swamt_back.png" />
        </button>
        <div />
      </div>
      <div class="words-container">
        <div
          v-if="guideVideos"
          class="big-letter-container"
          @click="onVideoModal"
        >
          <label>{{ slectedYin }}</label>
          <img src="../assets/video_play.png" />
        </div>
        <div v-else class="big-letter">
          <label>{{ slectedYin }}</label>
        </div>
        <div v-if="selectedTab === 'right'">
          <button
            v-if="showConsonant"
            :class="{
              'tab-button-default': combination !== 'consonant',
              'tab-button': combination === 'consonant',
            }"
            @click="onCombinationButton('consonant')"
          >
            韵母组合
          </button>
          <button
            v-if="showConsonant"
            :class="{
              'tab-button-default': combination !== 'initial',
              'tab-button': combination === 'initial',
            }"
            @click="onCombinationButton('initial')"
          >
            声母组合
          </button>
        </div>
        <div class="word-rows">
          <div v-for="word in items" :key="word.id" class="button-outer">
            <button
              v-bind:style="
                selectedWord === word.name
                  ? 'background-color: #279fb1; color: white;'
                  : 'background-color: white; color: #333;'
              "
              @click="onWord(word)"
              class="word-button"
            >
              {{ word.name }}
            </button>
            <div v-if="word.is_red" class="red-dot button-dot"></div>
          </div>
        </div>
      </div>
      <div class="control-panel">
        <div class="left-buttons">
          <button @click="onControlButton('big-thumb')" class="big">
            大赞
            <span v-if="statistics.bigThumb" class="plus-number"
              >+{{ statistics.bigThumb }}</span
            >
          </button>
          <button @click="onControlButton('small-thumb')" class="small">
            小赞
            <span v-if="statistics.smallThumb" class="plus-number"
              >+{{ statistics.smallThumb }}</span
            >
          </button>
          <button @click="onControlButton('no-thumb')" class="no">
            不赞<span v-if="statistics.noThumb" class="plus-number"
              >+{{ statistics.noThumb }}</span
            >
          </button>
        </div>
        <div>
          <button @click="onControlButton('big-draft')" class="big-draft">
            <span>大</span><span>飞</span><span>船</span>
            <span v-if="bigDraftCount" class="plus-number"
              >+{{ bigDraftCount }}</span
            >
          </button>
        </div>
      </div>
    </div>
    <div v-else class="letter-content">
      <div>
        <button
          :class="{
            'tab-button-default': selectedTab !== 'left',
            'tab-button': selectedTab === 'left',
          }"
          @click="onTabButton('left')"
        >
          声母
        </button>
        <button
          :class="{
            'tab-button-default': selectedTab !== 'right',
            'tab-button': selectedTab === 'right',
          }"
          @click="onTabButton('right')"
        >
          韵母
        </button>
      </div>
      <div class="letters-table">
        <div class="letters" v-if="selectedTab === 'left'">
          <div v-for="item in letters" class="letter-item" :key="item.letter">
            <button @click="onLetter(item)">
              {{ item.letter }}
            </button>
            <div v-if="item.is_red" class="red-dot"></div>
          </div>
        </div>
        <div class="letters" v-else-if="selectedTab === 'right'">
          <div
            v-for="item in consonants"
            class="letter-item"
            :key="item.letter"
          >
            <button @click="onLetter(item)">
              {{ item.letter }}
            </button>
            <div v-if="item.is_red" class="red-dot"></div>
          </div>
        </div>
      </div>

      <v-dialog width="80%" />

      <div class="bottom-button">
        <div v-if="uploading" class="loading-container">
          <div class="loader"></div>
        </div>
        <button v-else @click="onFinish" class="finish-button">结束</button>
      </div>
    </div>

    <div v-if="showModal" class="modal">
      <div class="initials-content">
        <div class="navBar">
          <div
            v-bind:style="
              v.video_id === selectedVideo
                ? 'background-color: #279fb1; color: white'
                : 'background-color: white; color: #279fb1'
            "
            v-for="v in guideVideos"
            :key="v.title"
            @click="onNavButton(v.video_id)"
            class="navButton"
          >
            {{ v.title }}
          </div>
        </div>
        <div id="player"></div>
      </div>
      <div class="close-button" @click="onModalClose">
        <img src="../assets/modal_close.png" />
      </div>
    </div>
  </div>
</template>
<script>
import { portalUrl } from '../static/config.js';
import queryString from 'query-string';
import question2s from '../static/swam_t_questions.json';
import Videos from '../static/videos.json';
import polyvPlayer from 'polyvPlayer';

import io from 'socket.io-client';
import CryptoJS from 'crypto-js';

import 'core-js/actual/array/group-by';
import { setTimeout } from 'timers';

import { removeArray, consonants, tableRows } from '../static/swamt_rows.js';

const nameToActionObj = {
  'big-thumb': 'BigAnima',
  'small-thumb': 'LittleAnima',
  'big-draft': 'UfoMove',
};

export default {
  data() {
    return {
      showStart: true,
      imLoading: true,
      items: undefined,
      startClicked: false,
      selectedWord: undefined,
      uploading: false,
      statistics: {},
      bigDraftCount: 0,
      showModal: false,
      guideVideos: undefined,
      selectedVideo: undefined,
      consonants,
      selectedTab: 'left',
      combination: 'consonant',
      showConsonant: true,
    };
  },

  mounted() {
    const searchString = location.hash.split('?')[1];
    const searchParams = queryString.parse(searchString);

    this._deviceId = searchParams.device_id;
    this._testId = searchParams.test_id;
    this._token = searchParams.token;

    localStorage.setItem(`${this._testId}_token`, this._token);
    localStorage.setItem(`${this._testId}_device`, this._deviceId);

    this._showLetters = searchParams.in_process === 'true';

    this._fetchLastSwamCTest();

    this._socket = io('https://app-test.ourbethel.cn:8085/ment_t', {
      query: {
        userId: `${this._deviceId}_controller`,
      },
      auth: {
        key: CryptoJS.MD5('bethel').toString(),
      },
      transports: ['websocket'], // 避免轮询
      autoConnect: true,
      reconnectionAttempts: 5,
    });

    this._socket.on('connect', () => {
      console.log('✅ Socket 已连接:', this._socket.id);
      this.imLoading = false;
      if (this._showLetters) {
        this.startClicked = true;
        this.showStart = false;
        this._wordCanClick = true;
        this._canClick = true;
      }
    });

    this._socket.on('disconnect', (reason) => {
      console.warn('⚠️ Socket 已断开:', reason);
    });

    this._socket.on('connect_error', (err) => {
      console.error('❌ Socket 连接错误:', err.message);
      this.$notify({
        group: 'foo',
        title: '提示',
        text: 'IM登录失败请稍后重试！',
      });
    });

    this._socket.on('animation_end', (data) => {
      console.log('-----animation_end', data);
      if (!this._classEnd) {
        const foundIndex = this._learningFlows.findIndex(
          (l) => l.word === this.selectedWord
        );

        if (foundIndex >= 0) {
          const _foundWord = this._learningFlows[foundIndex];

          _foundWord.actions = [
            ..._foundWord.actions,
            { action_name: this._actionName },
          ];

          this._learningFlows[foundIndex] = _foundWord;
        }

        this.flows = this._learningFlows.map((f) => {
          return {
            f: f.word,
            action: f.actions.groupBy((a) => a.action_name),
          };
        });

        const currentIndex = this.flows.findIndex(
          (f) => f.f === this.selectedWord
        );

        const foundWord = this.flows[currentIndex];

        if (foundWord) {
          this.statistics = {
            word: foundWord.f,
            bigThumb: foundWord.action['big-thumb']
              ? foundWord.action['big-thumb'].length
              : 0,
            smallThumb: foundWord.action['small-thumb']
              ? foundWord.action['small-thumb'].length
              : 0,
            noThumb: foundWord.action['no-thumb']
              ? foundWord.action['no-thumb'].length
              : 0,
          };
        } else {
          this.statistics = {};
        }

        if (this._actionName === 'big-draft') {
          this.bigDraftCount = Number(data);
        }

        localStorage.setItem(
          `${this._testId}_big_draft_count`,
          this.bigDraftCount
        );

        this._classEnd = this.bigDraftCount >= 7;

        if (this._classEnd) {
          this.items = undefined;
        }
        // store flow to local
        localStorage.setItem(this._testId, JSON.stringify(this._learningFlows));

        this._canClick = true;
      }
    });

    this._socket.on('go_into_main_sence', () => {
      console.log('-----go_into_main_sence');
      this.startClicked = true;
      this.showStart = false;
      this._wordCanClick = true;
      this._canClick = true;
    });

    const localData = localStorage.getItem(this._testId);

    if (localData === null || localData === '' || localData === undefined) {
      this._learningFlows = [];
    } else {
      this._learningFlows = JSON.parse(localData);
    }

    this.bigDraftCount = 0;
  },

  methods: {
    onStartButton() {
      this.imLoading = true;
      this._socket.emit('chat', {
        to: this._deviceId,
        eventName: 'CloseStartPanel',
        data: {},
      });
    },

    onLetter(x) {
      if (!this._classEnd) {
        this.slectedYin = x.letter;
        if (this.selectedTab === 'right') {
          const foundVideo = Videos.find((v) => v.initial === x.letter);
          if (foundVideo) {
            this.guideVideos = foundVideo.videos;
            this.selectedVideo = foundVideo.videos[0].video_id;
          } else {
            this.guideVideos = null;
          }
          if (x.left) {
            this.items = x.left;
            this.showConsonant = true;
            this.combination = 'consonant';
          } else {
            this.showConsonant = false;
            this.combination = 'initial';
            const _items = [];
            this.letters.forEach((f) => {
              const _name = `${f.letter}${this.slectedYin}`;
              if (!removeArray.includes(_name)) {
                _items.push({
                  name: _name,
                  is_red: f.is_red,
                });
              }
            });
            this.items = _items;
          }
        } else {
          const foundVideo = Videos.find((v) => v.initial === x.letter);
          if (foundVideo) {
            const _videos = [
              { title: '口型', video_id: foundVideo.mouth_video },
            ];
            foundVideo.skills.forEach((s, sIndex) => {
              _videos.push({
                title: `用法${sIndex + 1}`,
                video_id: s,
              });
            });
            this.guideVideos = _videos;
            this.selectedVideo = _videos[0].video_id;
          } else {
            this.guideVideos = null;
          }
          this.items = x.items;
        }
      } else {
        this.$notify({
          group: 'foo',
          title: '提示',
          text: '本地课程已经结束',
        });
      }
    },

    onWord({ name, id }) {
      if (this._wordCanClick && this._canClick) {
        const foundIndex = this._learningFlows.findIndex(
          (l) => l.word === name
        );

        if (foundIndex < 0) {
          let type;

          if (this.selectedTab === 'right') {
            if (this.showConsonant) {
              if (this.combination === 'consonant') {
                type = 1;
              } else {
                type = 2;
              }
            } else {
              type = 3;
            }
          } else {
            type = 0;
          }

          this._learningFlows.push({
            word: name,
            initial: this.slectedYin,
            actions: [],
            type,
          });
        }

        // store flow to local
        localStorage.setItem(this._testId, JSON.stringify(this._learningFlows));

        this.selectedWord = name;

        this._actionName = null;
        this._statistic();

        this._canClick = true;
        let obj = { action: 'DirectShowCard', text: id };
        if (this.selectedTab === 'right') {
          obj = { action: 'DirectShowText', text: name };
        }

        this._socket.emit('chat', {
          to: this._deviceId,
          eventName: obj.action,
          data: obj.text,
        });
      }
    },
    onControlButton(e) {
      if (this.selectedWord && this._canClick) {
        this._actionName = e;

        if (e === 'no-thumb') {
          const foundIndex = this._learningFlows.findIndex(
            (l) => l.word === this.selectedWord
          );

          if (foundIndex >= 0) {
            const _foundWord = this._learningFlows[foundIndex];

            _foundWord.actions = [
              ..._foundWord.actions,
              { action_name: this._actionName },
            ];

            this._learningFlows[foundIndex] = _foundWord;
          }

          this.flows = this._learningFlows.map((f) => {
            return {
              f: f.word,
              action: f.actions.groupBy((a) => a.action_name),
            };
          });

          const currentIndex = this.flows.findIndex(
            (f) => f.f === this.selectedWord
          );

          const foundWord = this.flows[currentIndex];

          if (foundWord) {
            this.statistics = {
              word: foundWord.f,
              bigThumb: foundWord.action['big-thumb']
                ? foundWord.action['big-thumb'].length
                : 0,
              smallThumb: foundWord.action['small-thumb']
                ? foundWord.action['small-thumb'].length
                : 0,
              noThumb: foundWord.action['no-thumb']
                ? foundWord.action['no-thumb'].length
                : 0,
            };
          } else {
            this.statistics = {};
          }
        } else {
          this._canClick = false;
          this._socket.emit('chat', {
            to: this._deviceId,
            eventName: nameToActionObj[e],
          });
        }
      }
    },
    onFinish() {
      this.$modal.show('dialog', {
        title: '提示',
        text: '是否结束本次的训练？',
        buttons: [
          {
            title: '取消',
            style: { color: 'white' },
            handler: () => {
              this.$modal.hide('dialog');
            },
          },
          {
            title: '确定',
            handler: () => {
              this._updateTest((success) => {
                if (success) {
                  this._socket.emit('chat', {
                    to: this._deviceId,
                    eventName: 'FinishGame',
                  });

                  this.$router.replace({
                    path: `/swamt_report/${this._testId}`,
                  });
                } else {
                  this.$notify({
                    group: 'foo',
                    title: '提示',
                    text: '请求失败，请稍后重试！',
                  });
                }
              });
            },
          },
        ],
      });
    },
    onBack() {
      if (this._canClick) {
        this.items = undefined;
      }
    },
    _fetchLastSwamCTest() {
      this.axios({
        url: `${portalUrl}dream/swam/c/fetch_last`,
        headers: {
          token: this._token,
        },
        params: {
          test_id: this._testId,
        },
        method: 'GET',
      }).then((res) => {
        console.log('-----res', res);
        if (res.data.success) {
          this._assembleLetter(res.data.data);
        } else {
          this._assembleLetter();
        }
      });
    },

    _assembleLetter(testData) {
      const letters = [];

      let initialRedObj = {};

      if (testData) {
        const keys = Object.keys(testData);
        keys.forEach((k) => {
          const kArray = testData[k];
          if (typeof kArray !== 'string') {
            const isAge = kArray.every((k) => k.isAge === true);
            const isSuccess = kArray.every((k) => k.type === 'Successful');
            initialRedObj[k] = isAge && !isSuccess;
          }
        });
      }

      tableRows.forEach((t) => {
        const found = letters.findIndex((l) => l.letter === t);
        if (found < 0) {
          if (testData) {
            letters.push({
              letter: t,
              is_red: initialRedObj[t],
              items: question2s.filter((f) => f.initial === t),
            });
          } else {
            letters.push({
              letter: t,
              items: question2s.filter((f) => f.initial === t),
            });
          }
        }
      });
      this.letters = letters;

      // this.startClicked = true;
      // this.showStart = false;

      // this._wordCanClick = true;
      // this._canClick = true;
    },

    _updateTest(callBack) {
      this.uploading = true;

      const _filteredFlows = this._learningFlows.filter(
        (f) => f.actions.length > 0
      );
      this.axios({
        url: `${portalUrl}swam/r/update`,
        headers: {
          token: this._token,
        },
        data: {
          test_id: this._testId,
          learning_flows: _filteredFlows,
        },
        method: 'POST',
      }).then((res) => {
        this.uploading = false;
        callBack(res.data.success);
      });
    },

    _statistic() {
      const foundIndex = this._learningFlows.findIndex(
        (l) => l.word === this.selectedWord
      );

      if (foundIndex >= 0 && this._actionName) {
        const _foundWord = this._learningFlows[foundIndex];

        _foundWord.actions = [
          ..._foundWord.actions,
          { action_name: this._actionName },
        ];

        this._learningFlows[foundIndex] = _foundWord;
      }

      this.flows = this._learningFlows.map((f) => {
        return {
          f: f.word,
          action: f.actions.groupBy((a) => a.action_name),
        };
      });

      const currentIndex = this.flows.findIndex(
        (f) => f.f === this.selectedWord
      );

      const foundWord = this.flows[currentIndex];

      if (foundWord) {
        this.statistics = {
          word: foundWord.f,
          bigThumb: foundWord.action['big-thumb']
            ? foundWord.action['big-thumb'].length
            : 0,
          smallThumb: foundWord.action['small-thumb']
            ? foundWord.action['small-thumb'].length
            : 0,
          noThumb: foundWord.action['no-thumb']
            ? foundWord.action['no-thumb'].length
            : 0,
        };
      } else {
        this.statistics = {};
      }
    },

    onVideoModal() {
      console.log('--------', window.innerWidth);
      this.showModal = true;

      setTimeout(() => {
        this.player = polyvPlayer({
          wrap: '#player',
          width: Number(window.innerWidth - 10),
          height: (Number(window.innerWidth - 10) * 480) / 854,
          vid: this.guideVideos[0].video_id,
          forceH5: true,
          allowFullscreen: true,
          autoPlay: true,
        });
      }, 100);
    },
    onNavButton(videoId) {
      this.selectedVideo = videoId;
      this.player.changeVid({ vid: videoId });
    },
    onModalClose() {
      this.showModal = false;
    },
    onTabButton(e) {
      this.selectedTab = e;
    },
    onCombinationButton(e) {
      this.combination = e;

      if (e === 'initial') {
        const _items = [];
        this.letters.forEach((f) => {
          const _name = `${f.letter}${this.slectedYin}`;
          if (!removeArray.includes(_name)) {
            _items.push({
              name: _name,
              is_red: f.is_red,
            });
          }
        });

        this.items = _items;
      } else {
        const found = consonants.find((c) => c.letter === this.slectedYin);
        this.items = found.left;
      }
    },
  },
};
</script>

<style scoped>
.main {
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  background: linear-gradient(
    to bottom left,
    #a4e0e9,
    white 40%,
    #ffe0d9,
    #a4e0e9
  );
  box-sizing: border-box;
  overflow-x: hidden;
}

.loading-container {
  position: absolute;
  height: 64px;
  width: 210px;
  bottom: 100px;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.star-button {
  position: absolute;
  height: 64px;
  width: 210px;
  border-radius: 32px;
  background-color: #ffae9a;
  border: none;
  font-size: 22px;
  font-weight: bolder;
  color: white;
  bottom: 100px;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  overflow: hidden;
}

.verison-text {
  position: absolute;
  bottom: 70px;
  text-align: center;
  width: 100%;
  color: gray;
}

.star-button:after,
.finish-button:after {
  content: '';
  background: #d9d9d9;
  display: block;
  position: absolute;
  padding-top: 300%;
  padding-left: 350%;
  margin-left: -20px !important;
  margin-top: -120%;
  opacity: 0;
  transition: all 0.8s;
}

.star-button:active:after,
.finish-button:active:after {
  padding: 0;
  margin: 0;
  opacity: 1;
  transition: 0s;
}

.title {
  color: #279fb1;
  font-weight: bold;
  font-size: 25px;
}

.logo {
  width: 178px;
  height: 232px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 15vh;
}

/* HTML: <div class="loader"></div> */
.loader {
  width: 30px;
  aspect-ratio: 1;
  display: grid;
  border-radius: 50%;
  background: linear-gradient(
        0deg,
        rgb(0 0 0/50%) 30%,
        #0000 0 70%,
        rgb(0 0 0/100%) 0
      )
      50%/8% 100%,
    linear-gradient(90deg, rgb(0 0 0/25%) 30%, #0000 0 70%, rgb(0 0 0/75%) 0)
      50%/100% 8%;
  background-repeat: no-repeat;
  animation: l23 1s infinite steps(12);
}
.loader::before,
.loader::after {
  content: '';
  grid-area: 1/1;
  border-radius: 50%;
  background: inherit;
  opacity: 0.915;
  transform: rotate(30deg);
}
.loader::after {
  opacity: 0.83;
  transform: rotate(60deg);
}
@keyframes l23 {
  100% {
    transform: rotate(1turn);
  }
}

.letter-content {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.letters-table {
  flex: 1;
  overflow-y: scroll;
}

.letters {
  padding-top: 20px;
  flex: 1;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.bottom-button {
  height: 100px;
  padding-bottom: costant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  display: flex;
  align-items: center;
  justify-content: center;
  /* width: 100vw; */
  /* background-color: blue; */
}

.letter-item {
  position: relative;
  width: 18vw;
  height: 18vw;
  margin-left: 5.6vw;
  margin-top: 15px;
  border-radius: 10vw;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19);
  /* overflow: hidden; */
}

.letter-item > button {
  width: 18vw;
  height: 18vw;
  border-radius: 10vw;
  border: 2.5px solid #279fb1;
  font-size: 28px;
  color: #01080f;
  font-weight: bolder;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.finish-button {
  position: relative;
  height: 60px;
  border-radius: 30px;
  width: 300px;
  background-color: #279fb1;
  border: none;
  font-size: 25px;
  color: white;
  font-weight: bold;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  overflow: hidden;
}

.control-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.swamt-back {
  width: 77px;
  height: 44px;
}

.words-container {
  flex: 1;
  overflow-x: scroll;
}

.control-panel {
  height: 330px;
  padding: 20px;
  box-sizing: border-box;
  padding-bottom: costant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  display: flex;
  flex-direction: row;
}

.control-container > .row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 20px;
}

.big-letter {
  background-color: #279fb1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 40px;
  color: white;
  font-weight: bold;
  margin-left: auto;
  margin-right: auto;
  width: 24vw;
  height: 24vw;
  border-radius: 12vw;
}

.big-letter-container {
  margin-left: auto;
  margin-right: auto;
  width: 40vw;
  height: 24vw;
  border-radius: 12vw;
  overflow: hidden;
  background-color: #279fb1;
  display: flex;
  align-items: center;
  justify-content: space-around;
  font-size: 50px;
  color: white;
  font-weight: bold;
}

.big-letter-container > img {
  width: 12vw;
  height: 12vw;
}
.word-rows {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: 20px;
}

.word-button {
  width: 26vw;
  height: 45px;
  border-radius: 22.5px;
  border: 2px solid #279fb1;
  margin-left: 5.5vw;
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: bold;
  color: #01080f;
  background-color: transparent;
}

.big-draft {
  height: 290px;
  width: 45vw;
  background-color: #279fb1;
  border-top-right-radius: 30px;
  border-bottom-right-radius: 30px;
  border: none;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-size: 30px;
  color: white;
  font-weight: bold;
  text-align: center;
}

.left-buttons {
  height: 290px;
  width: 45vw;
  display: flex;
  flex-direction: column;
  margin-right: 5vw;
}

.left-buttons > button {
  flex: 1;
  font-size: 30px;
  color: white;
  background-color: #279fb1;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border: none;
  border-top-left-radius: 30px;
  border-bottom-left-radius: 30px;
  font-weight: bold;
}

.left-buttons > .big,
.left-buttons > .small {
  margin-bottom: 5vw;
}

.back {
  background-color: transparent;
  border: none;
}

.plus-number {
  font-size: 16px;
}

.red-dot {
  background-color: red;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 100;
}

.modal {
  position: fixed;
  bottom: 0;
  left: 0;
  top: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 10000;
}

.initials-content {
  background-color: white;
  width: calc(100vw - 10px);
  height: calc((100vw - 10px) * 480 / 845 + 60px);
  position: absolute;
  left: 5px;
  top: calc((100vh - ((100vw - 10px) * 480 / 845 + 60px)) / 2);
  border-radius: 10px;
  overflow: hidden;
}

.navBar {
  height: 64px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.navButton {
  width: calc((100vw - 10px) * 0.18 + 4px);
  height: 38px;
  margin-left: calc(((100vw - 10px) * 0.24 - 16px) / 5);
  background-color: #279fb1;
  border-radius: 19px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  border: 2px solid #279fb1;
}

.close-button {
  position: absolute;
  top: calc(
    ((100vh - ((100vw - 10px) * 480 / 845 + 60px)) / 2) + (100vw - 10px) * 480 /
      845 + 70px
  );
  width: 40px;
  height: 40px;
  left: calc((100vw - 40px) / 2);
}

.close-button > img {
  width: 40px;
  height: 40px;
}

.tab-button {
  width: 110px;
  height: 35px;
  border-radius: 35px;
  border: none;
  margin: 10px;
  margin-bottom: 0;
  background-color: #279fb1;
  color: white;
  font-size: 16px;
  font-weight: bold;
}

.tab-button-default {
  width: 110px;
  height: 35px;
  border-radius: 35px;
  border: 2px solid #279fb1;
  margin: 10px;
  margin-bottom: 0;
  color: #279fb1;
  font-size: 16px;
  font-weight: bold;
}

.button-outer {
  position: relative;
}

.button-dot {
  position: absolute;
  top: -1px;
  right: 6px;
}
</style>
